<div class="snackbar-content">
  <span class="message">
    <mat-icon class="success-icon">check_circle</mat-icon>
    <span class="message-text">
      {{ data.message }}
    </span>
  </span>
  <span matSnackBarActions>
    <div class="close-button" (click)="snackBarRef.dismissWithAction()">
      Close
    </div>
  </span>
</div>
